/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_Week_BodyInputs */

const en_portal_rail_week_body = /** @type {(inputs: Portal_Rail_Week_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions, plan days and recovery in one week.`)
};

const pl_portal_rail_week_body = /** @type {(inputs: Portal_Rail_Week_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningi, plan i regeneracja w jednym tygodniu.`)
};

/**
* | output |
* | --- |
* | "Sessions, plan days and recovery in one week." |
*
* @param {Portal_Rail_Week_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_week_body = /** @type {((inputs?: Portal_Rail_Week_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_Week_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_week_body(inputs)
	return en_portal_rail_week_body(inputs)
});